import { AstNodeCategory, AstNodeType } from './node';
export class BooleanLiteral {
    constructor(token, value) {
        this.token = token;
        this.value = value;
        this.nodeType = AstNodeType.BooleanLiteral;
        this.nodeCategory = AstNodeCategory.Expression;
    }
    get Value() {
        return this.value;
    }
    set Value(val) {
        this.value = val;
    }
    tokenLiteral() {
        return this.token.literal;
    }
    toString() {
        return this.token.literal;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQm9vbGVhbkxpdGVyYWwuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvbGliL2FzdC9Cb29sZWFuTGl0ZXJhbC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFQSxPQUFPLEVBQUUsZUFBZSxFQUFFLFdBQVcsRUFBYyxNQUFNLFFBQVEsQ0FBQztBQUVsRSxNQUFNLE9BQU8sY0FBYztJQUN2QixZQUFvQixLQUFZLEVBQVUsS0FBYztRQUFwQyxVQUFLLEdBQUwsS0FBSyxDQUFPO1FBQVUsVUFBSyxHQUFMLEtBQUssQ0FBUztRQUV4RCxhQUFRLEdBQWdCLFdBQVcsQ0FBQyxjQUFjLENBQUM7UUFDbkQsaUJBQVksR0FBb0IsZUFBZSxDQUFDLFVBQVUsQ0FBQztJQUhBLENBQUM7SUFLNUQsSUFBSSxLQUFLO1FBQ0wsT0FBTyxJQUFJLENBQUMsS0FBSyxDQUFDO0lBQ3RCLENBQUM7SUFDRCxJQUFJLEtBQUssQ0FBQyxHQUFHO1FBQ1QsSUFBSSxDQUFDLEtBQUssR0FBRyxHQUFHLENBQUM7SUFDckIsQ0FBQztJQUVELFlBQVk7UUFDUixPQUFPLElBQUksQ0FBQyxLQUFLLENBQUMsT0FBTyxDQUFDO0lBQzlCLENBQUM7SUFFRCxRQUFRO1FBQ0osT0FBTyxJQUFJLENBQUMsS0FBSyxDQUFDLE9BQU8sQ0FBQztJQUM5QixDQUFDO0NBQ0oifQ==